import React, { useState, useEffect } from "react";
import adicionarUser from "../../../../API/Manager/adicionarUser";

import '../../../../styles/desktop/adicionar.css';

export default function Adicionar({ onBack }) {
    const [reportPermissions, setReportPermissions] = useState({
        Sindico: false,
        Administrador: true,
        Construtora: false,
        Fornecedor: false,
    });

    const [fullName, setFullName] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showBackButton, setShowBackButton] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowBackButton(true);
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const resetStatesToDefault = () => {
        setFullName("");
        setUsername("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        setErrorMessage("");
        setShowConfirmation(false);
    };

    const handlePermissionChange = (permission) => {
        setReportPermissions((prev) => ({
            ...prev,
            [permission]: !prev[permission],
        }));
    };

    const handleBackButtonClick = () => {
        setShowBackButton(false);
        setTimeout(() => onBack(), 300);
    };

    const handleSaveChanges = () => {
        setShowConfirmation(true);
    };

    // Validação do formato de e-mail
    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    // Validação da senha: no mínimo 8 caracteres, com letras maiúsculas, minúsculas e números
    const validatePassword = (password) => {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(password);
    };

    const confirmSaveChanges = async () => {
        setIsSaving(true);
        if (!fullName || !username || !email || !password || !confirmPassword) {
            setErrorMessage("Preencha todos os campos.");
            setIsSaving(false);
            setShowConfirmation(false);
            return;
        }

        if (!validateEmail(email)) {
            setErrorMessage("Formato de e-mail inválido.");
            setIsSaving(false);
            setShowConfirmation(false);
            return;
        }

        if (password !== confirmPassword) {
            setErrorMessage("As senhas não coincidem.");
            setIsSaving(false);
            setShowConfirmation(false);
            return;
        }

        if (!validatePassword(password)) {
            setErrorMessage("A senha deve conter no mínimo 8 caracteres, com letras maiúsculas, minúsculas e números.");
            setIsSaving(false);
            setShowConfirmation(false);
            return;
        }

        const storedUser = sessionStorage.getItem("user");
        const condominio = storedUser ? JSON.parse(storedUser).condominio : null;

        if (!condominio) {
            setErrorMessage("Erro ao obter o condomínio, reinicie a aplicação.");
            setIsSaving(false);
            setShowConfirmation(false);
            return;
        }

        try {
            // Converter as permissões para o formato esperado pelo backend (todas em minúsculas)
            const reportLowerCase = {
                sindico: reportPermissions.Sindico,
                administrador: reportPermissions.Administrador,
                construtora: reportPermissions.Construtora,
                fornecedor: reportPermissions.Fornecedor,
            };

            const usuario = {
                user: username,
                name: fullName,
                email: email,
                password: password,
                report: reportLowerCase,
                condominio: condominio,
                role: "default",
                table: "userdefault",
            };

            await adicionarUser(usuario);
            alert("Usuário adicionado com sucesso!");
            resetStatesToDefault();
        } catch (error) {
            console.error("Erro ao adicionar o usuário:", error);
            alert("Erro ao adicionar o usuário.");
        } finally {
            setIsSaving(false);
            setShowConfirmation(false);
        }
    };

    // Atualiza o campo username, removendo espaços e convertendo para minúsculas
    const handleUsernameChange = (e) => {
        let value = e.target.value;
        if (/\s/.test(value)) {
            setErrorMessage("Não pode inserir espaços no nome de usuário.");
            value = value.replace(/\s/g, "");
        } else {
            setErrorMessage("");
        }
        setUsername(value.toLowerCase());
    };

    // Impede a digitação de letras maiúsculas e de espaços no username
    const handleKeyDown = (e) => {
        if (e.key === " ") {
            e.preventDefault();
            setErrorMessage("Não pode inserir espaços no nome de usuário.");
        } else if (e.key.length === 1 && e.key !== e.key.toLowerCase()) {
            e.preventDefault();
            setErrorMessage("Não pode inserir letras maiúsculas no nome de usuário.");
        } else {
            setErrorMessage("");
        }
    };

    // Impede a colagem de texto contendo espaços ou letras maiúsculas no username
    const handlePaste = (e) => {
        e.preventDefault();
        let pastedText = e.clipboardData.getData('text');
        if (/\s/.test(pastedText)) {
            setErrorMessage("Não pode inserir espaços no nome de usuário.");
            pastedText = pastedText.replace(/\s/g, "");
        } else if (pastedText !== pastedText.toLowerCase()) {
            setErrorMessage("Não pode inserir letras maiúsculas no nome de usuário.");
        } else {
            setErrorMessage("");
        }
        setUsername(pastedText.toLowerCase());
    };

    return (
        <div className="adicionarContent">
            <div className="adicionar-header">
                <h1 className="adicionar-title">Criar usuário</h1>
            </div>
            
            <div className="adicionar-form adicionar-form-self">
                {errorMessage && <p className="passwordErrorText">{errorMessage}</p>}
                
                <label className="adicionar-label" htmlFor="fullName">Nome completo:</label>
                <input
                    className="adicionar-input"
                    id="fullName"
                    name="fullName"
                    placeholder="Nome completo"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                />

                <label className="adicionar-label" htmlFor="username">Usuário:</label>
                <input
                    className="adicionar-input"
                    id="username"
                    name="username"
                    placeholder="Crie um nome de usuário"
                    value={username}
                    onChange={handleUsernameChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                />

                <label className="adicionar-label" htmlFor="email">E-mail:</label>
                <input
                    className="adicionar-input"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Insira o e-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <label className="adicionar-label">Senha:</label>
                <input
                    className="adicionar-input"
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Insira a senha"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <label className="adicionar-label">Confirmar Senha:</label>
                <input
                    className="adicionar-input"
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    placeholder="Confirme a nova senha"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                
                <label className="alterar-label">Permissões de Reporte:</label>
                <div className="alterar-checkbox-group">
                    {Object.keys(reportPermissions).map((permission) => (
                        <label key={permission}>
                            <input
                                type="checkbox"
                                checked={reportPermissions[permission]}
                                onChange={() => handlePermissionChange(permission)}
                            />
                            {permission.charAt(0).toUpperCase() + permission.slice(1)}
                        </label>
                    ))}
                </div>
                
                <div className="adicionar-submit-button" onClick={handleSaveChanges}>
                    Salvar Alterações
                </div>
            </div>
        
            {showConfirmation && (
                <div className="confirmation-popup">
                    <p>Tem certeza que deseja salvar as alterações?</p>
                    <div className="popup-buttons">
                        <button onClick={confirmSaveChanges} disabled={isSaving}>
                            {isSaving ? "Salvando..." : "Sim"}
                        </button>
                        <button onClick={() => setShowConfirmation(false)} disabled={isSaving}>
                            Não
                        </button>
                    </div>
                </div>
            )}
            {showBackButton && (
                <div className="adicionar-back-button fade-in" onClick={handleBackButtonClick}>
                    Voltar
                </div>
            )}
        </div>
    );
}
